import Modal from "../Modal";
import "./SideModal.css";

function SideModal({ modalClass = 'modal side-modal', autoClose = false, ...rest }) {
    return <Modal modalClass={modalClass} autoClose={autoClose} {...rest} />
}

export default SideModal